__turbopack_context__.v({
  "byline": "Ruw68a_byline",
  "bylineAuthor": "Ruw68a_bylineAuthor",
  "bylineAuthorName": "Ruw68a_bylineAuthorName",
  "bylineAvatar": "Ruw68a_bylineAvatar",
  "bylineDate": "Ruw68a_bylineDate",
  "bylineDateFull": "Ruw68a_bylineDateFull",
  "bylineDateShort": "Ruw68a_bylineDateShort",
  "bylineDivider": "Ruw68a_bylineDivider",
  "category": "Ruw68a_category",
  "container": "Ruw68a_container",
  "excerpt": "Ruw68a_excerpt",
  "hideExcerpt": "Ruw68a_hideExcerpt",
  "inner": "Ruw68a_inner",
  "layout--horizontal": "Ruw68a_layout--horizontal",
  "layout--vertical": "Ruw68a_layout--vertical",
  "layoutLg--horizontal": "Ruw68a_layoutLg--horizontal",
  "layoutLg--vertical": "Ruw68a_layoutLg--vertical",
  "layoutMd--horizontal": "Ruw68a_layoutMd--horizontal",
  "layoutMd--vertical": "Ruw68a_layoutMd--vertical",
  "layoutSm--horizontal": "Ruw68a_layoutSm--horizontal",
  "layoutSm--vertical": "Ruw68a_layoutSm--vertical",
  "layoutXl--horizontal": "Ruw68a_layoutXl--horizontal",
  "layoutXl--vertical": "Ruw68a_layoutXl--vertical",
  "media": "Ruw68a_media",
  "mediaFull": "Ruw68a_mediaFull",
  "mediaThumb": "Ruw68a_mediaThumb",
  "mediaVideo": "Ruw68a_mediaVideo",
  "showBg": "Ruw68a_showBg",
  "size--lg": "Ruw68a_size--lg",
  "title": "Ruw68a_title",
});
